import { CookieRestClient } from '@idem/common/rest/cookie-rest-client';

export const crearPromocion = (
  datos: {
    titulo: string;
    beneficio: string;
    nombreComercio: string;
    inicio: string;
    fin: string;
    descripcion?: string;
    direccion?: string;
    condiciones?: string;
    latitud?: number;
    longitud?: number;
  },
  imagen?: File,
) => {
  const formData = new FormData();
  Object.entries(datos).forEach(([campo, valor]) => {
    if (valor !== undefined) {
      formData.append(campo, String(valor));
    }
  });
  if (imagen) {
    formData.append('imagen', imagen);
  }
  return new CookieRestClient().post('promociones', formData);
};

export const canjearCupon = async (token: string) => {
  try {
    await new CookieRestClient().post(`cupones/${token}/canjear`, {});
  } catch (error: any) {
    throw new Error(error.response?.data?.message);
  }
};
